import {
  Action,
  AnyAction,
  configureStore,
  ThunkAction,
} from '@reduxjs/toolkit';

import { createWrapper, HYDRATE } from 'next-redux-wrapper';

import reducers from './slices';

const reducer = (state: ReturnType<typeof reducers>, action: AnyAction)
  : ReturnType<typeof reducers> => {
  if (action.type === HYDRATE) {
    const nextState = {
      ...state,
      ...action.payload,
    };

    return nextState;
  }

  return reducers(state, action);
};


let store: ReturnType<typeof configureStore<ReturnType<typeof reducers>>>;

export const makeStore = () => {
  store = configureStore({
    reducer,
  });

  return store;
};


export type Store = ReturnType<typeof makeStore>;

export type AppDispatch = Store['dispatch'];

export type RootState = ReturnType<Store['getState']>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
export type GetStoreFunction = () => RootState

export const wrapper = createWrapper(makeStore, { debug: false });

export { store };
